import React from 'react';
import AnalyticsCard from '../../analytics-card/AnalyticsCard';
import { withAnalyticsAppContext } from '../../../context/analytics-app-context';
import './average-time-card.scss';

function AverageTimeCard({ appContext }) {
    const { loading } = appContext;
    const {
        analyticsCardTitle,
        averageTimeForVisitors
    } = appContext.analyticsData || {};
    return (
        <div className='average-time-card grid-item'>
            <AnalyticsCard
                isLoading={loading}
                title={'Average Time'}
                content={`${averageTimeForVisitors || 0}`}
                chipValue={analyticsCardTitle || ''}
            ></AnalyticsCard>
        </div>
    );
}

export default withAnalyticsAppContext(AverageTimeCard);
